import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    $(document).on("click", "#addAreabtn", function() {
        if (!$("#AddAreaSelect").val()) {
            $("#areaError").removeClass("hidden");
        } else {
            const areaId = $("#AddAreaSelect").val();
            const personId = $("#personId").val();
            const container = $("#areas");

            $("#addPersonArea .close").click();

            const params = {
                "data": {
                    areaId: areaId,
                    personId: personId
                },
                "url": "/api/area/addarea",
                "successMsg": "Successfully assigned area."
            };

            dataaccess.post(params).done(function(data) {
                container.html(data);
            });
        }
    });

    $(document).on("click", "#addPersonAreaBtn", function() {
        if ($("#AddAreaSelect option").length === 1) {
            let areas;
            dataaccess.get({ url: "/api/area/assignmentareas" }).done(function(result) {
                areas = result;
                for (let i = 0; i < result.length; i++) {
                    const areaName = areas[i].name;
                    const disabledText = areaName.includes("assigned") ? " disabled" : "";
                    $("#AddAreaSelect").append("<option value=\"" + areas[i].id + "\"" + disabledText + ">" + areaName + "</option>");
                }
            });
        }
    });
}

export const addArea = {
    init: init
};